import { render, staticRenderFns } from "./Segmentation.vue?vue&type=template&id=c8ee0af2&scoped=true"
import script from "./Segmentation.vue?vue&type=script&lang=js"
export * from "./Segmentation.vue?vue&type=script&lang=js"
import style0 from "./Segmentation.vue?vue&type=style&index=0&id=c8ee0af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ee0af2",
  null
  
)

export default component.exports